export const disabledSortFields = [
    'relevance',
    'price_low_to_high',
    'position',
    'news_from_date',
    'news_to_date',
    'ratings_summary',
    'has_gift',
    'ratings_count',
];

export const disabledParameters = [...disabledSortFields, 'hot_product', 'new_product', 'user_guide'];
